import { takeEvery, call, put } from 'redux-saga/effects';
import {
    fetchUserAnalyticsStart,
    fetchUserAnalyticsSuccess,
    fetchUserAnalyticsFail,
    fetchAssessmentsAnalyticsStart,
    fetchAssessmentsAnalyticsSuccess,
    fetchAssessmentsAnalyticsFail,
    fetchParticipationStatsStart,
    fetchParticipationStatsSuccess,
    fetchParticipationStatsFail,
    fetchSystemInsightsStart,
    fetchSystemInsightsSuccess,
    fetchSystemInsightsFail,
} from '../slices/analyticsSlice';
import { getRequest } from '../../network';
import {
    userAnalytics,
    assessmentAnalytics,
    participationStats,
    systemInsights,
} from '../apis';

// Generic handler for Analytics API calls
function* fetchAnalyticsSaga(action) {
    const { endpoint, successAction, failAction } = action.payload;

    try {
        const response = yield call(getRequest, endpoint);
        yield put(successAction(response));
    } catch (error) {
        yield put(failAction(error.message));
    }
}

// Individual sagas
function* fetchUserAnalyticsSaga(action) {
    yield fetchAnalyticsSaga({
        payload: {
            endpoint: userAnalytics.replace(':userId', action.payload.userId),
            successAction: fetchUserAnalyticsSuccess,
            failAction: fetchUserAnalyticsFail,
        },
    });
}

function* fetchAssessmentsAnalyticsSaga() {
    yield fetchAnalyticsSaga({
        payload: {
            endpoint: assessmentAnalytics,
            successAction: fetchAssessmentsAnalyticsSuccess,
            failAction: fetchAssessmentsAnalyticsFail,
        },
    });
}

function* fetchParticipationStatsSaga() {
    yield fetchAnalyticsSaga({
        payload: {
            endpoint: participationStats,
            successAction: fetchParticipationStatsSuccess,
            failAction: fetchParticipationStatsFail,
        },
    });
}

function* fetchSystemInsightsSaga() {
    yield fetchAnalyticsSaga({
        payload: {
            endpoint: systemInsights,
            successAction: fetchSystemInsightsSuccess,
            failAction: fetchSystemInsightsFail,
        },
    });
}

// Watcher saga
export function* watchAnalytics() {
    yield takeEvery(fetchUserAnalyticsStart.type, fetchUserAnalyticsSaga);
    yield takeEvery(fetchAssessmentsAnalyticsStart.type, fetchAssessmentsAnalyticsSaga);
    yield takeEvery(fetchParticipationStatsStart.type, fetchParticipationStatsSaga);
    yield takeEvery(fetchSystemInsightsStart.type, fetchSystemInsightsSaga);
}